import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { useCart } from "@/context/CartContext";
import { useAuth } from "@/context/AuthContext";
import { api, brl } from "@/lib/api";
import { Minus, Plus, Trash2 } from "lucide-react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";

export const CartDrawer = () => {
  const { items, open, setOpen, remove, setQty, subtotal, count } = useCart();
  const { user } = useAuth();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const checkout = async () => {
    if (!user) {
      setOpen(false);
      toast.error("Entre na sua conta para finalizar a compra.");
      navigate("/entrar");
      return;
    }
    setLoading(true);
    try {
      const { data } = await api.post("/payments/checkout", {
        items: items.map((i) => ({ slug: i.slug, quantity: i.quantity, size: i.size })),
        origin_url: window.location.origin,
        user_id: user.id,
      });
      window.location.href = data.checkout_url;
    } catch (e) {
      toast.error("Não foi possível iniciar o pagamento.");
      setLoading(false);
    }
  };

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetContent data-testid="cart-drawer" className="bg-surface border-l border-line text-white w-full sm:max-w-md flex flex-col">
        <SheetHeader>
          <SheetTitle className="font-serif-display text-3xl font-light text-white text-left">
            Sua Sacola <span className="text-rose text-lg">({count})</span>
          </SheetTitle>
        </SheetHeader>

        <div className="flex-1 overflow-y-auto -mx-6 px-6 py-4 space-y-5">
          {items.length === 0 && (
            <p className="text-white/50 text-sm mt-8" data-testid="cart-empty">Sua sacola está vazia.</p>
          )}
          {items.map((i) => (
            <div key={i.key} data-testid={`cart-item-${i.slug}`} className="flex gap-4 border-b border-line pb-5">
              <img src={i.image} alt={i.name} className="w-20 h-24 object-cover" />
              <div className="flex-1">
                <p className="font-body text-sm text-white">{i.name}</p>
                {i.size && <p className="text-white/40 text-xs mt-0.5">Tam: {i.size}</p>}
                <p className="text-rose text-sm mt-1">{brl(i.price)}</p>
                <div className="flex items-center gap-3 mt-2">
                  <button onClick={() => setQty(i.key, i.quantity - 1)} className="border border-line p-1 hover:border-rose"><Minus size={12} /></button>
                  <span className="text-sm w-5 text-center">{i.quantity}</span>
                  <button onClick={() => setQty(i.key, i.quantity + 1)} className="border border-line p-1 hover:border-rose"><Plus size={12} /></button>
                  <button onClick={() => remove(i.key)} data-testid={`remove-${i.slug}`} className="ml-auto text-white/40 hover:text-rose"><Trash2 size={15} /></button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {items.length > 0 && (
          <div className="border-t border-line pt-5 space-y-4">
            <div className="flex justify-between items-baseline">
              <span className="label-caps text-white/60">Subtotal</span>
              <span data-testid="cart-subtotal" className="font-serif-display text-2xl text-white">{brl(subtotal)}</span>
            </div>
            <p className="text-white/40 text-xs">Frete e impostos calculados no checkout · até 12x no cartão</p>
            <button onClick={checkout} disabled={loading} data-testid="checkout-button"
              className="w-full bg-rose hover:bg-rose-hover text-ink font-bold py-4 label-caps transition-colors duration-300 disabled:opacity-50">
              {loading ? "Redirecionando..." : "Finalizar Compra"}
            </button>
          </div>
        )}
      </SheetContent>
    </Sheet>
  );
};
